import { PROMOTION_TYPES } from '@weft/types';
import type { PromotionType,
  FreeTrialPromotionConfiguration,
  CreditPromotionConfiguration,
  PercentagePromotionConfiguration,
  PromotionConfigurationInput, 
  PromotionConfiguration, 
  CreditPromotionConfigurationInput,
  PercentagePromotionConfigurationInput } from '@weft/types';
import type { FreeTrialPromotionConfigurationInput } from '@weft/types';

export function isTrialPromotionConfiguration(promotionType: PromotionType, promotionConfiguration: PromotionConfiguration): promotionConfiguration is FreeTrialPromotionConfiguration {
  return promotionType === PROMOTION_TYPES.FreeTrial;
}

export function isCreditPromotionConfiguration(promotionType: PromotionType, promotionConfiguration: PromotionConfiguration): promotionConfiguration is CreditPromotionConfiguration {
  return promotionType === PROMOTION_TYPES.Credit;
}

export function isPercentagePromotionConfiguration(promotionType: PromotionType, promotionConfiguration: PromotionConfiguration): promotionConfiguration is PercentagePromotionConfiguration {
  return promotionType === PROMOTION_TYPES.Percentage;
}

export function isTrialPromotionConfigurationInput(promotionType: PromotionType, promotionConfiguration: PromotionConfigurationInput): promotionConfiguration is FreeTrialPromotionConfigurationInput {
  return promotionType === PROMOTION_TYPES.FreeTrial;
}

export function isCreditPromotionConfigurationInput(promotionType: PromotionType, promotionConfiguration: PromotionConfigurationInput): promotionConfiguration is CreditPromotionConfigurationInput {
  return promotionType === PROMOTION_TYPES.Credit;
}

export function isPercentagePromotionConfigurationInput(promotionType: PromotionType, promotionConfiguration: PromotionConfigurationInput): promotionConfiguration is PercentagePromotionConfigurationInput {
  return promotionType === PROMOTION_TYPES.Percentage;
}